<template>
  <WelcomeView @start="onStart" />
</template>

<script>
import WelcomeView from './components/WelcomeView.vue';

export default {
  name: 'App',
  components: { WelcomeView },
  methods: {
    onStart() {
      console.log('Launching CubeSolv');
    },
  },
};
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  height: 100%;
  background: #0a0c18;
}
* { box-sizing: border-box; }
</style>
